import React from 'react';

export const SettingsUsersFormCard = ({
    title,
    backLabel = 'Volver a usuarios',
    onBack,
    children,
}) => {
    return (
        <div className="row">
            <div className="col-12 col-xl-9 col-xxl-8 mx-auto">
                <div className="card stretch stretch-full card__no-border">
                    <div className="card-body pt-3">
                        <div className="d-flex align-items-center justify-content-between mb-4">
                            <h5 className="fw-bold mb-0">{title}</h5>
                            <button type="button" className="btn btn-light-brand btn-sm" onClick={onBack}>
                                {backLabel}
                            </button>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};
